module.exports = __webpack_public_path__ + "img/hyl1_title.fbeb10ba.png";